export default {
  多元活动连接全球市场: "多元活动连接全球市场",
  共享全球顶级资源与学术支持: "共享全球顶级资源与学术支持，助您盈在投资起点",
  了解更多: "了解更多",
  敬请期待: "敬请期待",
  每个认真交易的人: "每个认真交易的人，都值得被认真对待",
  pageTitleH1: `<span class="sm">赚取最高</span><span class="red">18%</span><span class="lg">年化管理费</span> `,
  pageTitleH2: "管理资金量越大，年化收益越高",
  activityListMetaData: [
    {
      label: "市场活动",
      list: [
        {
          id: "2-12",
          img: require("@/assets/image/activityList/banner2_12.png?v=2.0.0"),
          bannerTitle: `<img
          class="img-logo"
          src="${require("@/assets/image/logo/logo_row_white.svg")}"
          alt="logo"
        />
        <div class="barca2526-title">交易赢巴萨球票<br/> 亲临<span>巴萨</span>25/26赛季主场</div>
        <img
          class="img-arrow"
          src="${require("@/assets/image/activityList/arrow.svg")}"
          alt=""
        />
        `,
          bannerBoxClass: "barca2526-title-box",
          bannerSubTitle: "",
          title: "交易赢巴萨球票 亲临巴萨25/26赛季主场",
          subtitle:
            "在全球最佳券商EBC交易，即可赢取巴塞罗那足球俱乐部主场球票，机票、酒店全程礼遇，见证红蓝军团在绿茵场上的精彩演绎。",
          url: "/activityList/barca2526",
          time: "",
        },
        {
          id: "2-6",
          img: require("@/assets/image/activityList/Mid-AutumnFestival.jpg"),
          title: "EBC中秋双重好礼",
          subtitle:
            "首存即赠EBC 588元定制礼盒，累计交易还可赢取茅台、iPhone17 等豪礼。月圆共盈，与EBC同行享圆满！",
          url: "/activityList/Mid-AutumnFestival",
          time: "",
        },
        {
          id: "2-4",
          img: require("@/assets/image/activityList/banner2_4New.png"),
          bannerTitle: "加入基金经理成长计划",
          bannerSubTitle: '赚取<span class="red">18%</span>年化管理费',
          title: "基金经理成长计划",
          subtitle:
            "这是一项专为优秀交易者打造的资产增值计划！根据交易员的管理资金量发放月度奖金，奖金比例高达年化18%！",
          url: "/pay",
          time: "",
        },
        {
          id: "2-3",
          img: require("@/assets/image/activityList/banner2_3.png"),
          bannerTitle: "创作即收益<br/>月月现金到账",
          bannerTitleClass: "creator-incentives-title",
          bannerSubTitle: "",
          bannerSubTitleClass: "creator-incentives-subtitle",
          title: "创作者激励计划",
          subtitle: "加入EBC创作者激励计划，轻松变现影响力",
          url: "/activityList/creator-incentives",
          time: "",
        },
        {
          id: "2-9",
          img: require("@/assets/image/activityList/banner2_9.png"),
          title: "EBC百万美金交易大赛Ⅱ完美收官",
          subtitle: "免费复制冠军收益",
          url: "/million-dollar-challenge-2",
          time: "",
        },
        // {
        //   id: "2-10",
        //   img: require("@/assets/image/activityList/messi.png"),
        //   title: "在EBC交易赢梅西签名限量球衣",
        //   subtitle: "活动时间：2025年3月1日 - 2025年3月31日",
        //   url: "/trade-for-messi",
        //   time: "",
        // },
        {
          id: "2-7",
          img: require("@/assets/image/activityList/banner2_7.png"),
          title: "EBC携手Trading view连接全球资源",
          subtitle: "限时领Trading view会员权益 全球市场动态即时掌控",
          url: "/TradingView",
          time: "",
        },

        {
          id: "2-5",
          img: require("@/assets/image/activityList/banner2_5.png"),
          title: "免费领取订单流",
          subtitle: "助您夺回交易世界的主动权",
          url: "/orderflow/",
          time: "",
        },
        {
          id: "2-1",
          img: require("@/assets/image/activityList/banner2_1.png"),
          title: "百万美金交易大赛",
          subtitle: "悬赏百万美金  寻找交易之王",
          url: "/win1",
          time: "",
        },
      ],
    },
    {
      label: "品牌动态",
      list: [
        {
          id: "3-5",
          img: require("@/assets/image/activityList/banner3_5.png"),
          title: "EBC亮相智利Money Expo2025",
          subtitle:
            "全球最佳券商EBC 以最大赞助商身份，亮相智利Money Expo 2025，分享前沿知识、展示最新技术，助力拉美金融生态未来发展。",
          url: "",
          time: "2025年8月27-28日",
        },
        {
          id: "3-4",
          img: require("@/assets/image/activityList/banner3_4.png"),
          title: "EBC金融集团亮相2025拉美iFX EXPO",
          subtitle:
            "EBC作为钻石赞助商参加拉美iFX EXPO，展位为18号，分享如何在全球贸易格局重塑下，通过创新金融服务助力投资者把握机遇、规避风险。",
          url: "/LearningCenterInfo?id=LEARN-423-66C",
          time: "2025年4月9-10日",
        },
        {
          id: "3-3",
          img: require("@/assets/image/activityList/banner3_3.png"),
          title: "EBC亮相墨西哥Money Expo 2025",
          subtitle:
            "EBC作为铂金赞助商，亮相墨西哥Money Expo 2025！在这场墨西哥顶级的交易盛会中，共同探索金融科技新趋势，发现交易新机遇！",
          url: "/LearningCenterInfo?id=LEARN-782-60B",
          time: "2025年2月26-27日",
        },
        {
          id: "3-1",
          img: require("@/assets/image/activityList/banner3_1.png"),
          title: "如何利用气候经济学，挖掘投资机遇",
          subtitle: `"经济学家究竟在做什么" 结合时下热议话题，探讨如何利用经济学推动政客的改进，促进经济繁荣。`,
          url: "/partners/oxford",
          time: "2024年11月14日",
        },
        {
          id: "3-2",
          img: require("@/assets/image/activityList/banner3_2.png"),
          title: "EBC联合牛津大学研讨会",
          subtitle: `本次线下研讨会将于11月14日14:30 (GMT)在牛津大学基督教会学院展开，线上同步直播，并向全球投资者开放。`,
          url: "/partners/oxford",
          time: "2024年3月6日",
        },
      ],
    },
    {
      label: "积分商城",
      list: [
        {
          id: "1-1",
          img: require("@/assets/image/activityList/banner1_1.png"),
          title: "EBC积分商城 认真对待每份期待",
          subtitle: "积分畅兑梦想豪车 、巴萨周边、热门单品",
          url: "https://client.ebc-pro.com/signup-b",
          time: "",
          target: "_blank",
        },
      ],
    },
  ],
};
